import { Navigation } from "@/components/layout/Navigation";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppFloat } from "@/components/layout/WhatsAppFloat";
import { Chatbot } from "@/components/chatbot/Chatbot";
import { Hero } from "@/components/sections/Hero";
import { QuickFacts } from "@/components/sections/QuickFacts";
import { CoreCapabilities } from "@/components/sections/CoreCapabilities";
import { Services } from "@/components/sections/Services";
import { WhyChooseUs } from "@/components/sections/WhyChooseUs";
import { Industries } from "@/components/sections/Industries";
import { Portfolio } from "@/components/sections/Portfolio";
import { Technologies } from "@/components/sections/Technologies";
import { FAQ } from "@/components/sections/FAQ";
import { Contact } from "@/components/sections/Contact";
import { useRevealAll } from "@/hooks/useReveal";

export default function Home() {
  const ref = useRevealAll();
  return (
    <>
      <Navigation />
      <main data-testid="home-page" ref={ref}>
        <Hero />
        <QuickFacts />
        <CoreCapabilities />
        <Services />
        <WhyChooseUs />
        <Industries />
        <Portfolio />
        <Technologies />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Chatbot />
    </>
  );
}
